export const EVENT_LABEL = {
  articleImage: `article_image`,
  headerMenuButton: `Hamburger menu`,
};

export const EVENT_TYPE = {
  click: `click`,
  headerOverlapping: `header_overlapping`,
  newsBlock: `news-block`,
  menuLink: `menu-link`,
  articleLink: `article-link`,
  readMoreBtn: `read-more`,
  headerMenuButton: `header-menu-button`,
  readAlso: `read-also`,
};

export const EVENT_NAME = {
  customMeasurement: `custom_measurement`,
  impression: `impression`,
  click: `click`,
};

const CLASSES = {
  headerMenu: `.js-header-menu`,
  headerMenuLink: `.js-header-menu-link`,
  newsBlock: `.js-news-block`,
  readAlso: `.js-read-also`,
};

export const sendMeasurement = (name, label, type, customParameters = {}) => {
  if (window.gtag === undefined) {
    console.error(
      `There is no gtag in window. Can't send "${name}" event  with ${JSON.stringify({
        label,
        type,
      })} payload`,
    );
    return;
  }

  window.gtag(`event`, name, {
    label,
    type,
    ...customParameters,
  });
};

const createImpressionObserver = (loadCallback = () => {}) =>
  new IntersectionObserver(
    (changes) => {
      changes.filter((change) => change.isIntersecting).forEach(loadCallback);
    },
    { threshold: 0.5, rootMargin: `0px` },
  );

const newsBlockImpressionObserver = createImpressionObserver(({ target = {} } = {}) => {
  sendMeasurement(EVENT_NAME.impression, target.dataset.newsType, EVENT_TYPE.newsBlock);
  newsBlockImpressionObserver.unobserve(target);
});

export const initMenuAnalytics = (container = document.body) => {
  const $menuBlocks = container.querySelectorAll(CLASSES.headerMenu);

  $menuBlocks.forEach(($menuBlock) => {
    const $menuLinks = $menuBlock.querySelectorAll(CLASSES.headerMenuLink);

    $menuLinks.forEach(($link) => {
      $link.addEventListener(`click`, () => {
        sendMeasurement(EVENT_NAME.click, $link.dataset.label, EVENT_TYPE.menuLink);
      });
    });
  });
};

export const initNewsBlocksAnalytics = (container = document.body) => {
  const $newsBlocks = container.querySelectorAll(CLASSES.newsBlock);

  $newsBlocks.forEach(($newsBlock) => {
    const $articles = $newsBlock.querySelectorAll(`article`);
    const $readMoreBtn = $newsBlock.querySelector(`.c-action-link`);

    $articles.forEach(($article, index) => {
      $article.addEventListener(`click`, () => {
        sendMeasurement(EVENT_NAME.click, $newsBlock.dataset.newsType, EVENT_TYPE.articleLink, {
          article_number: index + 1,
        });
      });
    });

    if ($readMoreBtn) {
      $readMoreBtn.addEventListener(`click`, () => {
        sendMeasurement(EVENT_NAME.click, $newsBlock.dataset.newsType, EVENT_TYPE.readMoreBtn);
      });
    }

    newsBlockImpressionObserver.observe($newsBlock);
  });
};

export const initReadAlsoAnalytics = (container = document.body) => {
  const $readAlsoBlocks = container.querySelectorAll(CLASSES.readAlso);

  $readAlsoBlocks.forEach(($readAlso) => {
    $readAlso.addEventListener(`click`, () => {
      sendMeasurement(EVENT_NAME.click, $readAlso.dataset.newsType, EVENT_TYPE.readAlso);
    });

    newsBlockImpressionObserver.observe($readAlso);
  });
};

export const initRecommendationAnalytics = ($container) => {
  const $recommendedArticles = $container.querySelectorAll(`article`);
  const $readMoreBtn = $container.querySelector(`.c-action-link`);

  $recommendedArticles.forEach(($article, index) => {
    $article.addEventListener(`click`, () => {
      sendMeasurement(EVENT_NAME.click, $container.dataset.newsType, EVENT_TYPE.articleLink, {
        article_number: index + 1,
      });
    });
  });

  if ($readMoreBtn) {
    $readMoreBtn.addEventListener(`click`, () => {
      sendMeasurement(EVENT_NAME.click, $container.dataset.newsType, EVENT_TYPE.readMoreBtn);
    });
  }

  newsBlockImpressionObserver.observe($container);
};
